import React from 'react';
import {createSvgIcon} from '../../common/icons/create-svg-icon';

export const CustomTriangleIcon = createSvgIcon(
  <path d="M 16 4.90625 L 15.125 6.40625 L 4.71875 24.5 L 3.875 26 L 28.125 26 L 27.28125 24.5 L 16.875 6.40625 Z M 16 8.9375 L 24.65625 24 L 7.34375 24 Z " />
);
